import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { sendEmail, validateEmail } from "../../api/emailApi";
import { authAtom, registerAtom } from "../../recoil/atoms";

export const useSendEmail = () => {
  const onError = ({
    response: {
      status,
      data: { code },
    },
  }) => {
    if (status === 500) {
      if (code === "EMAIL_SEND_FAILURE") {
        alert("이메일 발송이 실패했습니다. 재전송 버튼을 눌러 주세요.");
      }
    }
  };
  const onSuccess = () => {};
  return useMutation(sendEmail, {
    onError,
    onSuccess,
  });
};

// 인증 확인 훅
export const useValidateEmail = () => {
  const navigate = useNavigate();

  const setAuthAtom = useSetRecoilState(authAtom);
  const setRegisterAtom = useSetRecoilState(registerAtom);
  const onError = ({ response: { status } }) => {
    // 에러 발생 시 로직(status가 200 이 아닐때 이곳으로옴)
    if (status === 401) {
      setAuthAtom({ isLoggedIn: false, username: null, name: null });
    }
  };
  const onSuccess = ({ data: { isValid, message } }) => {
    if (!isValid) {
      setRegisterAtom((prev) => ({
        ...prev,
        emailMessage: message,
      }));
    } else {
      navigate("/register/password");
    }
  };
  return useMutation(validateEmail, {
    onError,
    onSuccess,
  });
};
